const e = {
  color: {
    required: "#e54a32ff"
  }
};
export {
  e as label
};
